import { CHAIN_IDS } from '@/utils/wagmi'
import { useAccount } from 'wagmi'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Typography } from '@/components/ui/typography'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Connector } from '@/components/connector'
import { toast } from 'sonner'
import { isAddress } from 'viem'

export default function PortfolioIndexPage() {
  const [label, setLabel] = useState('')
  const router = useRouter()
  const { address } = useAccount()

  useEffect(() => {
    if (address) {
      router.push(`/portfolio/${address}`)
    }
  }, [address])

  const onTrack = () => {
    try {
      if (isAddress(label)) {
        router.push(`/portfolio/${label}`)
      } else {
        toast.error('invalid address')
      }
    } catch (e) {
      console.error(e)
      toast.error((e as Error).message)
    }
  }

  return (
    <main className="container mx-auto py-4 pb-24 px-6">
      <Typography className={'text-5xl mb-6 font-semibold'}>Moonforge portfolio</Typography>
      <Typography className={'text-xl text-foreground/80 mb-12'}>Track all your assets, in one place.</Typography>
      <div className="w-[500px] max-w-full">
        <div className="flex items-center gap-4 mb-4">
          <Input placeholder={'Enter address'} size={'lg'} value={label} onChange={(e) => setLabel(e.target.value)} />
          <Button size={'lg'} onClick={onTrack}>
            Track
          </Button>
        </div>
        <Connector />
      </div>
    </main>
  )
}

PortfolioIndexPage.chains = CHAIN_IDS
